import { ReactNode } from 'react';
import { useAuthenticatedFetch } from '../../api/use-authenticated-fetch';
import { UserContext } from './use-user';

export interface UserContextType {
  authenticatedFetch: (input: RequestInfo, init?: RequestInit) => Promise<Response>;
}

type UserProviderProps = {
  children: ReactNode;
};

// TODO: to be deleted. This provider used to have all the user info but this is no longer the case. Not doing it now because too many files would change.
export const UserProvider = ({ children }: UserProviderProps) => {
  const authenticatedFetch = useAuthenticatedFetch();

  const value: UserContextType = {
    authenticatedFetch,
  };

  return <UserContext.Provider value={value}>{children}</UserContext.Provider>;
};
